import ChatGPTLogo from './ChatGPTLogo'
import PerplexityLogo from './PerplexityLogo'
import GeminiLogo from './GeminiLogo'
import ClaudeLogo from './ClaudeLogo'

export { ChatGPTLogo, PerplexityLogo, GeminiLogo, ClaudeLogo }
export type { AILogoProps } from './ChatGPTLogo'

export interface AIAgent {
  name: 'ChatGPT' | 'Perplexity' | 'Gemini' | 'Claude'
  short: string
  Logo: typeof ChatGPTLogo
  brandColor: string
}

export const aiAgents: readonly AIAgent[] = [
  { name: 'ChatGPT', short: 'GPT', Logo: ChatGPTLogo, brandColor: '#10A37F' },
  { name: 'Perplexity', short: 'PPLX', Logo: PerplexityLogo, brandColor: '#20808D' },
  { name: 'Gemini', short: 'GEM', Logo: GeminiLogo, brandColor: '#4893FC' },
  { name: 'Claude', short: 'CLD', Logo: ClaudeLogo, brandColor: '#CC785C' },
]
